/* Canes:. Small, no libraries.
   1) Size buttons: when a product mixes Youth and Adult sizes, show them as two labeled rows
      (Youth first). Only the visible label changes; the input values Dawn uses stay the same.
   2) Phones: a sticky Add to cart bar on product pages once the real button is off screen.
      Until the shopper picks a size it says "Choose size" and scrolls to the picker. */
(function () {
  'use strict';

  function groupSizes(root) {
    (root || document).querySelectorAll('variant-radios fieldset.product-form__input:not([data-cx])').forEach(function (fs) {
      fs.setAttribute('data-cx', '1');
      var inputs = Array.prototype.slice.call(fs.querySelectorAll('input[type="radio"]'));
      var youth = inputs.filter(function (i) { return /^youth\b/i.test(i.value); });
      if (!youth.length || youth.length === inputs.length) return;
      var make = function (name) {
        var g = document.createElement('div'); g.className = 'cx-size-group';
        var l = document.createElement('span'); l.className = 'cx-size-group__label'; l.textContent = name;
        var o = document.createElement('div'); o.className = 'cx-size-group__opts';
        g.appendChild(l); g.appendChild(o); return { el: g, opts: o };
      };
      var gy = make('Youth'), ga = make('Adult');
      inputs.forEach(function (input) {
        var label = fs.querySelector('label[for="' + input.id + '"]');
        var target = /^youth\b/i.test(input.value) ? gy.opts : ga.opts;
        target.appendChild(input);
        if (label) {
          target.appendChild(label);
          if (target === gy.opts) {
            var t = label.firstChild;
            if (t && t.nodeType === 3) t.nodeValue = t.nodeValue.replace(/^\s*youth\s*-?\s*/i, '');
          }
        }
      });
      fs.appendChild(gy.el); fs.appendChild(ga.el);
    });
  }

  function stickyBar() {
    var info = document.querySelector('product-info[id^="ProductInfo-"][id$="__main"]');
    if (!info || document.querySelector('.cx-sticky')) return;
    var submit = info.querySelector('.product-form__submit');
    if (!submit) return;
    var titleEl = info.querySelector('.product__title h1');
    var multi = info.querySelectorAll('variant-radios input[type="radio"], variant-selects option').length > 1;
    var picked = !multi || /[?&]variant=/.test(location.search);
    var bar = document.createElement('div');
    bar.className = 'cx-sticky'; bar.setAttribute('aria-hidden', 'true');
    bar.innerHTML = '<div class="cx-sticky__info"><span class="cx-sticky__title"></span><span class="cx-sticky__price"></span></div><button type="button" class="cx-btn" tabindex="-1"></button>';
    document.body.appendChild(bar);
    var btn = bar.querySelector('button');
    bar.querySelector('.cx-sticky__title').textContent = titleEl ? titleEl.textContent.trim() : '';
    function sync() {
      var p = info.querySelector('.price .price-item--last') || info.querySelector('.price-item');
      bar.querySelector('.cx-sticky__price').textContent = p ? p.textContent.trim() : '';
      if (!picked) { btn.textContent = 'Choose size'; btn.disabled = false; return; }
      btn.textContent = submit.disabled ? 'Sold out' : 'Add to cart';
      btn.disabled = submit.disabled;
    }
    info.addEventListener('change', function () { picked = true; setTimeout(sync, 400); });
    btn.addEventListener('click', function () {
      if (!picked) {
        var picker = info.querySelector('variant-radios, variant-selects');
        if (picker) picker.scrollIntoView({ behavior: 'smooth', block: 'center' });
        return;
      }
      submit.click();
    });
    sync();
    if (!('IntersectionObserver' in window)) return;
    new IntersectionObserver(function (entries) {
      var on = !entries[0].isIntersecting;
      bar.classList.toggle('is-on', on);
      document.body.classList.toggle('cx-has-sticky', on);
      if (on) sync();
    }).observe(submit);
  }

  function init() {
    groupSizes(document);
    if (window.matchMedia('(max-width: 989px)').matches) stickyBar();
    // quick add modals load the product form later
    var pending = false;
    new MutationObserver(function () {
      if (pending) return; pending = true;
      setTimeout(function () { pending = false; groupSizes(document); }, 60);
    }).observe(document.body, { childList: true, subtree: true });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init); else init();
})();

/* Canes: on phones the Shopify chat bubble shows just its icon (label hidden), so it stops covering prices, sizes and buttons.
   The chat app's shadow DOM is open; we add one style rule to it. Does nothing if the chat app is off. */
(function () {
  if (!window.matchMedia('(max-width: 749px)').matches) return;
  var tries = 0;
  var t = setInterval(function () {
    tries++;
    try {
      var c = document.querySelector('shopify-chat');
      var rt = c && c.shadowRoot && c.shadowRoot.querySelector('shopify-agent-runtime');
      var root = rt && rt.shadowRoot;
      if (root && root.querySelector('.activator')) {
        if (!root.querySelector('style[data-cx]')) {
          var s = document.createElement('style'); s.setAttribute('data-cx', '1');
          s.textContent = '.activator__label{display:none!important}.activator{padding:0!important;gap:0!important;width:4.8rem!important;min-width:4.8rem!important;height:4.8rem!important;justify-content:center!important}.activator-nudge{right:12px!important}';
          root.appendChild(s);
        }
        clearInterval(t);
      }
    } catch (e) { clearInterval(t); }
    if (tries > 40) clearInterval(t);
  }, 500);
})();
